/**
 * Regular expressions specific to TipTap editor functionality
 */

// Pattern to match any content between double mustache braces - used for references
export const REFERENCE_DOUBLE_MUSTACHE_PATTERN = /\{\{([^}]+)\}\}/g;

// Pattern to match simple reference format (inputs or steps followed by ID)
export const REFERENCE_SIMPLE_PATTERN = /{{(inputs|steps)\.([\w-]+)}}/g;

// Pattern to match reference span in HTML
export const REFERENCE_SPAN_PATTERN =
  /<span\s+[^>]*data-reference[^>]*data-id=\"([^"]+)\"[^>]*><\/span>/g;

// Pattern to match reference with data-reference="" and id
export const REFERENCE_SPAN_ID_PATTERN =
  /<span\s+data-reference=\"\"\s+id=\"([^"]+)\"[^>]*><\/span>/g;

// Pattern to match reference with id and data-reference=""
export const REFERENCE_ID_SPAN_PATTERN =
  /<span\s+id=\"([^"]+)\"\s+data-reference=\"\"[^>]*><\/span>/g;

// Pattern to match reference with id and data-reference in any order
export const REFERENCE_COMPLEX_PATTERN =
  /<span\s+[^>]*id=\"([^"]+)\"[^>]*data-reference[^>]*><\/span>/g;

// Pattern to match UUID format
export const UUID_PATTERN =
  /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;

// Pattern to match empty paragraphs
export const EMPTY_PARAGRAPH_PATTERN = /<p><\/p>/g;

// Pattern to detect function call format (e.g., askMemory("","",0.5))
export const FUNCTION_CALL_PATTERN = /\w+\([^)]*\)/;
